import React, { useRef, useCallback, useEffect } from "react";
import Portal from "../portal/portal";
import styled from "styled-components";
import styles from "./statusPop.scss";
import FallbackImg from "../../assets/images/fallbackImg.png";

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(44, 44, 44, 0.7);
  backdrop-filter: blur(10px);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 111;
  @media screen and (max-width: 425px) {
    background: rgba(44, 44, 44, 0.7);
    height: 100vh;
    //margin-top: -110px;
    top: 0;
  }

  @media screen and (min-width: 765px) {
    //margin-top: -138px;
    top: 0;
  }
  @media screen and (min-width: 1200px) {
    // margin-left: -54px;
    // margin-top: -25px;
    // top: 25px;
    top: 0;
    left: 0;
    z-index: 9999;
    position: fixed;
    margin-top: 0px;
  }
`;

const ModalWrapper = styled.div`
  width: 326px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  position: relative;
  border-radius: 10px;
  z-index: 99999999999;
  display: flex;
  flex-direction: column;
  justify-content: center;

  overflow: hidden;

  @media screen and (min-width: 993px) {
    width: 460px;
    z-index: 99999999999;
    border-radius: 20px;
  }
`;

export const StatusPopup = ({ showModal, setShowModal, product }) => {
  const modalRef = useRef();

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };
  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
      }
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  return (
    <>
      {showModal ? (
        <Portal>
          <Background onClick={closeModal} ref={modalRef}>
            <ModalWrapper showModal={showModal}>
              <svg
                className={styles["close"]}
                onClick={() => setShowModal((prev) => !prev)}
                width="10"
                height="11"
                viewBox="0 0 10 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.80469 5.75L9.53906 3.01562C9.89453 2.6875 9.89453 2.14062 9.53906 1.8125L8.9375 1.21094C8.60938 0.855469 8.0625 0.855469 7.73438 1.21094L5 3.94531L2.23828 1.21094C1.91016 0.855469 1.36328 0.855469 1.03516 1.21094L0.433594 1.8125C0.078125 2.14062 0.078125 2.6875 0.433594 3.01562L3.16797 5.75L0.433594 8.51172C0.078125 8.83984 0.078125 9.38672 0.433594 9.71484L1.03516 10.3164C1.36328 10.6719 1.91016 10.6719 2.23828 10.3164L5 7.58203L7.73438 10.3164C8.0625 10.6719 8.60938 10.6719 8.9375 10.3164L9.53906 9.71484C9.89453 9.38672 9.89453 8.83984 9.53906 8.51172L6.80469 5.75Z"
                  fill="#2C2C2C"
                />
              </svg>

              <div className={styles["wrapper"]}>
                <span className={styles["heading"]}>{product.msg}</span>
                <div className={styles["content-div"]}>
                  <div className={styles["img-div"]}>
                    {product.image ? (
                      <img src={product.image} alt="product" />
                    ) : (
                      <img
                        style={{ objectFit: "contain" }}
                        src={FallbackImg}
                        alt=""
                      />
                    )}
                  </div>
                  <div className={styles["product-details"]}>
                    <p className={styles["brand-name"]}>
                      {product.productBrand}
                    </p>
                    <h2 className={styles["product-name"]}>
                      {product.productName}
                    </h2>
                    <span className={styles["product-status"]}>
                      {product.productStatusLabel}
                    </span>
                  </div>
                </div>
                <div className={styles["btn-div"]}>
                  <button
                    className={styles["submit-btn"]}
                    onClick={() => setShowModal((prev) => !prev)}
                  >
                    確認
                  </button>
                </div>
              </div>
            </ModalWrapper>
          </Background>
        </Portal>
      ) : null}
    </>
  );
};
